<template>
  <div class="column page_redemptions_warning p0">
    <div class="balance_container p0" v-if="bluAccount">
      <div style="display: flex; align-items: center">
        <h1 class="grey_normal">
          {{ $tc("msg.balance", 1) }}
        </h1>
        <img
          v-if="!toggleBalance"
          src="../../../assets/images/hide_balance_icon.png"
          style="width: 35px; margin-left: 10px; margin-top: 5px"
          class="pointer"
          @click="() => toggle()"
        />
        <img
          v-else
          src="../../../assets/images/show_balance_icon.png"
          style="width: 35px; margin-left: 10px; margin-top: 5px"
          class="pointer"
          @click="() => toggle()"
        />
      </div>

      <div v-if="toggleBalance">
        <div
          v-for="balance in balances"
          v-bind:key="balance.id"
          class="balance_arround"
        >
          <div v-if="selectedBlue" class="balance_row">
            <div class="right_header_content">
              <span
                class="icon_class_1 mr_10"
                v-html="iconSets[balance.icon]"
              ></span>
              <span class="grey_normal">{{ $t(`msg.${balance.text}`) }}</span>
            </div>

            <div class="balance_content_inside capitalize">
              <img
                class="blu_balance_img"
                src="../../../assets/images/blue_icon.svg"
              />
              <div class="balanc_blu grey_normal">
                <div class="tal_r">
                  <span class="right_blu">{{ getBalance(balance.type) }}</span>
                  BLUE
                  <span
                    class="icon_class_03"
                    :style="
                      balance.type == 'locked' ? '' : 'color: transparent'
                    "
                    v-html="iconSets.general_lock"
                  ></span>
                </div>
              </div>
            </div>
          </div>

          <!-- aqui-->

          <div v-else class="balance_row pb_10">
            <div class="right_header_content">
              <span
                class="icon_class_1 mr_10"
                v-html="iconSets[balance.icon]"
              ></span>
              <span class="grey_normal">{{
                $t(`msg.${balance.text_USDT}`)
              }}</span>
            </div>
            <div
              class="balance_content_inside capitalize"
              style="display: flex; flex-direction: column"
            >
              <div
                class="balance_content_inside_100"
                v-for="coin in pairCoins"
                v-bind:key="coin.id"
              >
                <!-- <div class="w10"> -->
                  <span
                    class="blu_balance_img icon_class_1 background_ val_m"
                    :class="`background_${coin.symbol}`"
                  ></span>
                <!-- </div> -->
                <div class="balanc_blu grey_normal">
                  <div class="tal_r">
                    <span class="right_blu" v-if="coin.symbol == 'USDT'">{{
                      getBalanceUsdt(balance.type)
                    }}</span>

                    <span class="right_blu" v-else>{{
                      (getBalanceUsdt(balance.type) /
                        (coin.value / bluValue[0].value))
                        | decimalsCrypto(6)
                    }}</span>

                    {{ coin.symbol }}

                    <span
                      class="icon_class_03"
                      :style="
                        balance.type == 'locked' ? '' : 'color: transparent'
                      "
                      v-html="iconSets.general_lock"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="column balance_container component_card" v-else>
      <h2>{{ $t("msg.loading_balance") }}</h2>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  created() {
    this.getUnlockedBalance();
    this.createPairCoinsArray();
  },
  props: ["selectedBlue"],
  data: () => ({
    activatedTeste: "",
    unLockedBalance: "",
    pairCoins: [],
    toggleBalance: false,
    balances: [
      {
        id: 1,
        type: "available",
        text: "available",
        text_USDT: "available",
        icon: "balance_status_available",
      },
      {
        id: 2,
        type: "locked",
        text: "waiting_for_aprove",
        text_USDT: "waiting_for_aprove",
        icon: "balance_status_waiting",
      },
      {
        id: 3,
        type: "total",
        text: "total_redeem",
        text_USDT: "total_redeem_USDT",
        icon: "balance_status_total",
      },
    ],
  }),
  methods: {
    toggle() {
      this.toggleBalance = !this.toggleBalance;
    },
    getUnlockedBalance() {
      if (this.bluAccount) {
        let totalBalance = this.bluAccount.balance;
        let lockedBalace = this.bluAccount.locked;
        let balance = "";

        this.unLockedBalance = totalBalance - lockedBalace;
      }
    },

    getBalance(type) {
      if (this.bluAccount) {
        if (type == "available") {
          let total = this.bluAccount.balance;
          let locked = this.bluAccount.locked;
          let balance = total - locked;
          return balance.toFixed(6);
        }
        if (type == "locked") {
          let balance = this.bluAccount.locked;
          return balance.toFixed(6);
        }
        if (type == "total") {
          let balance = this.bluAccount.balance;
          return balance.toFixed(6);
        }
      } else {
        return "balance erro";
      }
    },

    getBalanceUsdt(type) {
      if (this.usdtAccount) {
        if (type == "available") {
          let total = this.usdtAccount.balance;
          let locked = this.usdtAccount.locked;
          let balance = total - locked;
          return balance.toFixed(4);
        }
        if (type == "locked") {
          let balance = this.usdtAccount.locked;
          return balance.toFixed(4);
        }
        if (type == "total") {
          let balance = this.usdtAccount.balance;
          return balance.toFixed(4);
        }
      } else {
        return "balance erro";
      }
    },

    createPairCoinsArray() {
      this.pairCoins.push(this.usdtValue[0]);
    },
  },
  computed: {
    ...mapGetters([
      "bluAccount",
      "usdtAccount",
      "bluValue",
      "btcValue",
      "ethValue",
      "rasValue",
      "usdtValue",
    ]),
  },
  watch: {
    bluAccount: function () {
      this.getUnlockedBalance();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/private/services/RedemptionBalance.vue